import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgMetro = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M19 2H5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2ZM5 4h14v11H5V4Z" />
      <circle cx={7} cy={13.5} r={1} />
      <circle cx={17} cy={13.5} r={1} />
      <path d="M17 5H7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Zm-1 2v3H8V7h8ZM15.336 15.253a1 1 0 0 1 1.322-.006l.09.089 4 4.5a1 1 0 0 1-1.406 1.417l-.09-.089-4-4.5a1 1 0 0 1 .084-1.411ZM7.793 15.293a1 1 0 0 1 1.497 1.32l-.083.094-4.5 4.5a1 1 0 0 1-1.497-1.32l.083-.094 4.5-4.5Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgMetro)
const Memo = memo(ForwardRef)
export default Memo
